import { render, staticRenderFns } from "./online_actors.vue?vue&type=template&id=4a8224a6&scoped=true"
import script from "./online_actors.vue?vue&type=script&lang=js"
export * from "./online_actors.vue?vue&type=script&lang=js"
import style0 from "./online_actors.vue?vue&type=style&index=0&id=4a8224a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8224a6",
  null
  
)

export default component.exports